import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-broadcasting-gallery-add-video-dialog',
  templateUrl: './broadcasting-gallery-add-video-dialog.component.html',
  styleUrls: ['./broadcasting-gallery-add-video-dialog.component.scss']
})
export class BroadcastingGalleryAddVideoDialogComponent implements OnInit {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  base64: string;
  url: string;

  constructor(public dialogRef: MatDialogRef<BroadcastingGalleryAddVideoDialogComponent>,
    private validationImageService: ValidationImageService) {
    this.dialogRef.disableClose = true;
  }

  ngOnInit() {
  }

  public uploadVideoClicker() {
    this.uploadInput.nativeElement.value = null;
    this.uploadInput.nativeElement.click();
  }

  public uploadAsset(event) {
    const file = event.target.files[0];
    const img = new Image();
    this.validationImageService.toBase64(file).subscribe(
      (base64) => {
        this.base64 = base64;
      },
      (error) => {
      }
    );
  }

  public accept() {
    if (this.validateForm()) {
      if (!this.isYoutubeUrl(this.url)) {
        if (this.base64 && !this.url) {
          this.dialogRef.close({ type: 'video', file: this.base64, url: null, info: 1 });
        } else if (!this.base64 && this.url) {
          this.dialogRef.close({ type: 'video', file: null, url: this.url, info: 1 });
        }
      } else {
        this.dialogRef.close({ type: 'youtube', file: null, url: this.url, info: 1 });
      }
    }
  }

  public cancel() {
    this.dialogRef.close();
  }

  public isYoutubeUrl(url) {
    const youtubeVideoRegExp = /^(http(s)??\:\/\/)?(www\.)?((youtube\.com\/watch\?v=)|(youtu.be\/))([a-zA-Z0-9\-_])+/;
    if (youtubeVideoRegExp.test(url)) {
      return true;
    }
    return false;
  }

  public validateForm() {
    if (this.base64 && !this.url) {
      return true;
    } else if (!this.base64 && this.url) {
      return true;
    }
    return false;
  }

}
